import { NodeAIArgument, NodeIndex } from '@components/Flow/Nodes';

export type AITool = AIToolBase | AIToolBucketRetrieval | AIToolBucketSearch | AIToolHangupCall | AIToolStaticDocument;

export type AIToolBase = {
  id: string;
  assistant_id: string;
  name: string;
  description: string;
  instructions: string;
  execution: ToolExecution;
  type: ToolType;
  metadata: AIToolMetadata;
  arguments: NodeAIArgument[];
  settings: AIToolSettings;
};

export interface AIToolBucketSearch extends AIToolBase {
  execution: ToolExecution.BUCKET_SEARCH;
  metadata: BucketSearchMetadata;
}

export interface AIToolBucketRetrieval extends AIToolBase {
  execution: ToolExecution.BUCKET_RETRIEVAL;
  metadata: BucketRetrievalMetadata;
}

export interface AIToolStaticDocument extends AIToolBase {
  execution: ToolExecution.STATIC_DOCUMENT;
  metadata: StaticDocumentMetadata;
}

export interface AIToolHangupCall extends AIToolBase {
  execution: ToolExecution.HANGUP_CALL;
  metadata: undefined;
}

export interface AIToolTelnyxAPISearch extends AIToolBase {
  execution: ToolExecution.TELNYX_API_SEARCH;
  metadata: TelnyxAPISearchMetadata;
}

export interface AIToolTelnyxPricingCalculator extends AIToolBase {
  execution: ToolExecution.TELNYX_PRICING_CALCULATOR;
  metadata: TelnyxPricingCalculatorMetadata;
}

export interface AIToolHTTPRequest extends AIToolBase {
  execution: ToolExecution.HTTP_REQUEST;
  metadata: HTTPRequestMetadata;
}

export enum ToolModification {
  CREATE = 'create',
  EDIT = 'edit',
}

export enum ToolType {
  FLOW = 'flow',
  VOICE = 'voice',
}

export enum ToolExecution {
  BUCKET_SEARCH = 'bucket_search',
  BUCKET_RETRIEVAL = 'bucket_retrieval',
  STATIC_DOCUMENT = 'static_document',
  HANGUP_CALL = 'hangup',
  TELNYX_PRICING_CALCULATOR = 'pricing_calculator',
  TELNYX_API_SEARCH = 'api_search',
  HTTP_REQUEST = 'http_request',
  UNSUPPORTED = 'unsupported',
}

export type AIToolSettings = {
  tool_choice: string;
  events: AIToolEvent[];
};

export type AIToolEvent = {
  id: string;
  type: string;
  value: string;
  trigger: AIToolEventTrigger;
};

export type AIToolEventTrigger = 'after_execution';
export type AIToolMetadata =
  | BucketSearchMetadata
  | BucketRetrievalMetadata
  | StaticDocumentMetadata
  | TelnyxAPISearchMetadata
  | TelnyxPricingCalculatorMetadata
  | HTTPRequestMetadata
  | undefined;

export type TelnyxPricingCalculatorMetadata = {
  product: string;
  countryCode: string;
};

export type TelnyxAPISearchMetadata = {
  search_descriptor: string;
  bucket_search_type: string;
  max_tokens: number;
  max_results: number;
  query_parameters: string;
  body_parameters: string;
  responses: string;
  webhooks: string;
  sdk: string;
  backup_output: string;
  backup_tool_choice: string;
};

export type HTTPRequestParameter = {
  id: string;
  name: string;
  value: string;
  type: 'body' | 'query' | 'header';
  required: boolean;
};

export type HTTPRequestMetadata = {
  method: string;
  url: string;
  query_parameters: HTTPRequestParameter[];
  header_parameters: HTTPRequestParameter[];
  body_format: 'json' | 'form';
  body_parameters: HTTPRequestParameter[];
  body_json: string;
  auth_enabled: 'true' | 'false';
  auth_secret_name: string;
  approval_required: 'true' | 'false';
};

export type BucketSearchMetadata = {
  search_descriptor: string;
  bucket_search_type: string;
  max_tokens: number;
  max_results: number;
  indexes: NodeIndex[];
  backup_output: string;
  backup_tool_choice: string;
};

export type BucketRetrievalMetadata = {
  bucket_ids: string[];
  max_num_results: number;
};

export type StaticDocumentMetadata = {
  output: string;
};

export type ToolDrawerOpen = {
  tool: AITool;
  modification: ToolModification;
  isCopyMode?: boolean;
};
